import React from "react";
import FooterDesktop from "./FooterDesktop";
import FooterMobile from "./FooterMobile";
import { FooterDataType } from "src/assets/Types/Redesign/FooterDataType.type";
import { FooterContext } from "@contexts/FooterContext";

const Footer: React.FC<FooterDataType> = data => {
  return (
    <FooterContext.Provider value={data}>
      <div className="bg-sun-500 py-20 md:py-12 md:px-10 sm:px-5 container-footer">
        <FooterDesktop />
        <FooterMobile />
      </div>
    </FooterContext.Provider>
  );
};

export default Footer;
